import React from 'react'
import { RegularCheckBox } from '../../HouseStyle/Components/Checkboxes';


const CheckboxCell = ({row, handleSelection, selectedIds, pk}) => {
    const isSelected = selectedIds.includes(row.original[pk]);
    const handleClick = (e) => {
        e.stopPropagation(); // Prevent the click from bubbling to the td element
    };

    return (
        <div onClick={handleClick}>
            <RegularCheckBox
                label=""
                value={isSelected}
                setValue={(checked) => handleSelection(row.original[pk], checked)}
            />
        </div>
    );
}

export default CheckboxCell